/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MonthPlanChangeFixedCostPlanRequestDto
 */
export interface MonthPlanChangeFixedCostPlanRequestDto {
  /**
   *
   * @type {string}
   * @memberof MonthPlanChangeFixedCostPlanRequestDto
   */
  fundId: string;
  /**
   *
   * @type {number}
   * @memberof MonthPlanChangeFixedCostPlanRequestDto
   */
  plan: number;
}

export function MonthPlanChangeFixedCostPlanRequestDtoFromJSON(json: any): MonthPlanChangeFixedCostPlanRequestDto {
  return MonthPlanChangeFixedCostPlanRequestDtoFromJSONTyped(json, false);
}

export function MonthPlanChangeFixedCostPlanRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MonthPlanChangeFixedCostPlanRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    fundId: json["fundId"],
    plan: json["plan"],
  };
}

export function MonthPlanChangeFixedCostPlanRequestDtoToJSON(
  value?: MonthPlanChangeFixedCostPlanRequestDto | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    fundId: value.fundId,
    plan: value.plan,
  };
}
